/* bundle-builder.js
   New file. Added by Nimbl, August 2026. Not part of Kalles 4.3.0.
   Read snippets/bundle-builder-readme.liquid before running a theme update.
   That snippet is the current record of which files to preserve. The older
   BUNDLE-PICKER-FILES.md at the theme root predates the essential builder.

   Two builders live in this file and share one cart implementation:
     [data-bundle-builder]     Pattern A, sections/bundle-builder.liquid
                               Buy 1 mattress, get N accessories free.
     [data-essential-builder]  Pattern B, sections/essential-bundle-builder.liquid
                               Buy any N trigger items, get the reward free.

   Selection state and the cart call only. All product data is rendered
   server side by the two sections. Nothing is fetched on load.

   Cart integration mirrors Kalles' own add to cart so there is one cart, not two:
   POST items[] to T4Sroutes.cart_add_url with the drawer sections requested,
   then hand the returned sections to T4SThemeSP.Cart.renderContents. Falls back
   to the theme's documented cart:refresh:opend event if that is not loaded yet. */

(function () {
  'use strict';

  if (window.__bbInit) return;
  window.__bbInit = true;

  /* Keyboard flag for the focus rings, see the matching comment in the CSS.
     Tab turns the rings on, the next pointer press turns them off. Without
     this, mobile browsers paint the focus outline on tap, which reads as a
     second border on selection and an orphan border after deselection. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') document.documentElement.classList.add('bb-kbd');
  });
  document.addEventListener('pointerdown', function () {
    document.documentElement.classList.remove('bb-kbd');
  }, true);

  /* Resolved at call time, not once at parse time: this file is deferred but
     T4Sconfigs is written by the theme's own footer script, and the merchant can
     switch the mini cart off in settings. Asking for a section the theme will
     never render is wasted work on every add. */
  function cartSections() {
    var cfg = window.T4Sconfigs;
    return (cfg && cfg.cartType === 'disable') ? 'cart_data' : 'cart_data,mini_cart';
  }

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  /* Touch safety net for the hidden radios. On some mobile engines the first
     tap on a label for a visually hidden radio is spent on hover simulation
     and never activates the input, while checkboxes activate fine. So after
     any touch tap on the label, give the native activation a beat, and if the
     radio still is not checked, check it by hand. Where the native path works
     this is a no-op, and mouse and keyboard are untouched. */
  function forceRadioTap(input) {
    var label = input.nextElementSibling;
    if (!label || label.tagName !== 'LABEL') return;
    label.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'mouse') return;
      if (input.disabled) return;
      setTimeout(function () {
        if (input.checked || input.disabled) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, 80);
    }, { passive: true });
  }

  function parseAttr(el, name, fallback) {
    try { return JSON.parse(el.getAttribute(name)); } catch (e) { return fallback; }
  }

  /* Shopify money format, mirroring the standard helper so totals match the cart. */
  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    /* A money format is free to carry markup, for example
       <span class=notranslate>${{amount}} AUD</span>. Everything this function
       returns is written to textContent, where a tag would be read out as
       literal text, so strip tags before formatting. */
    var fmt = String(format || '${{amount}}').replace(/<[^>]*>/g, '');

    function thousands(num, precision, thousand, decimal) {
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousand || ','));
      var cents = parts[1] ? (decimal || '.') + parts[1] : '';
      return dollars + cents;
    }

    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Quantity per card. Shared by both builders.                         */
  /* ------------------------------------------------------------------ */

  /* Shopify's Buy X Get Y counts UNITS, not distinct products, on the trigger
     side and on the reward side. Verified live on this store, August 2026:
     a Queen mattress plus 2x Buckwheat plus 1x Low Profile filled all three
     reward slots and took $395 off, and 2x one pillow satisfied "buy any 2" on
     its own. So one card can stand for several units, and every count in both
     builders is a count of units rather than of cards.

     The quantity lives on the wrap as data-qty rather than in a JS side table,
     so it sits in the DOM beside data-variant-id and cannot drift out of step
     with the markup. A card that has never been touched, or one that has been
     deselected, reads 1: selecting a card is always worth exactly one unit. */
  function readQty(wrap) {
    var n = parseInt(wrap.getAttribute('data-qty'), 10);
    return (n > 0) ? n : 1;
  }

  function writeQty(wrap, n) {
    wrap.setAttribute('data-qty', n > 0 ? n : 1);
  }

  /* Wires one card's quantity control. The buttons sit inside the card wrap but
     OUTSIDE the <label>, the same rule the essential builder's size picker
     follows: inside the label, every press on plus or minus would toggle the
     checkbox as well. ctx is the builder, which supplies units(), unitCap(),
     strings and render(). */
  function bindQty(wrap, input, ctx) {
    var down = wrap.querySelector('[data-bb-qty-down]');
    var up = wrap.querySelector('[data-bb-qty-up]');
    if (!down && !up) return;

    function step(delta) {
      /* The row is hidden on an unselected card, so this is a safety net rather
         than a live path. */
      if (!input || !input.checked) return;
      var next = readQty(wrap) + delta;
      /* Minimum one. Taking the item out altogether stays the card's job, so
         the minus button simply stops here rather than deselecting behind the
         customer's back. */
      if (next < 1) return;
      var cap = ctx.unitCap();
      if (delta > 0 && cap > 0 && ctx.units() + delta > cap) return;
      writeQty(wrap, next);
      ctx.render();
    }

    if (down) down.addEventListener('click', function () { step(-1); });
    if (up) up.addEventListener('click', function () { step(1); });
  }

  /* Paints one card's quantity row. Called from render, so the readout, the
     plus button and the cap always move together. The row shows only on a
     selected card: an unselected card has no quantity to talk about. */
  function renderQty(wrap, input, ctx) {
    var row = wrap.querySelector('[data-bb-qty]');
    if (!row) return;

    var on = !!(input && input.checked);
    row.hidden = !on;

    /* textContent, not innerHTML. The readout is merchant text with a number
       substituted into it and has no business carrying markup, and the aria
       labels naming the product are server rendered and escaped, so no product
       title is ever assembled into markup here. */
    var count = wrap.querySelector('[data-bb-qty-count]');
    if (count) count.textContent = fill(ctx.strings.qtyReadout || 'x [q]', { q: on ? readQty(wrap) : 1 });

    var cap = ctx.unitCap();
    var up = wrap.querySelector('[data-bb-qty-up]');
    if (up) up.disabled = !on || (cap > 0 && ctx.units() >= cap);
    var down = wrap.querySelector('[data-bb-qty-down]');
    if (down) down.disabled = !on;
  }

  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

  /* Discount titles come from the cart API and end up inside innerHTML. */
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return ESCAPES[c]; });
  }

  /* One add to cart for both builders. */
  function postCart(items) {
    var base = (window.T4Sroutes && window.T4Sroutes.cart_add_url) || '/cart/add';
    return fetch(base + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: cartSections(),
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); });
  }

  /* Hand off to Kalles' own drawer so there is a single cart implementation. */
  function openCartDrawer(sections) {
    var T = window.T4SThemeSP;
    var $ = window.jQuery_T4NT;

    try {
      if (T && T.Cart && typeof T.Cart.renderContents === 'function' && sections) {
        T.isATCSuccess = true;
        if ($) $(document).trigger('add:cart:success').trigger('add:cart:upsell');
        T.Cart.renderContents(sections);
        return;
      }
    } catch (e) { /* fall through to the event below */ }

    document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
  }

  function readCart(done) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { done(cart || null); })
      .catch(function () { done(null); });
  }

  /* The discount name Shopify actually applied, for example "Essential Bundle Luxe"
     or "Queen Mattress Bundle". Absent until the cart qualifies, so treat it as
     optional everywhere.

     ids is the set of variant ids THIS submit posted. Only those lines are read,
     so a discount already sitting on some unrelated line the customer added
     earlier is never reported as ours.

     The three step fallback chain has to stay intact. Live /cart.js on this store
     carries no discount_allocations key at all: it exposes titles through
     line_level_discount_allocations and through item.discounts, and which one is
     populated varies, so all three steps are load bearing. */
  function discountTitle(cart, ids) {
    if (!cart) return '';
    var items = cart.items || [];
    var scoped = !!(ids && ids.length);
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (scoped && ids.indexOf(Number(it.variant_id)) === -1) continue;
      var allocs = it.discount_allocations || it.line_level_discount_allocations || [];
      for (var j = 0; j < allocs.length; j++) {
        var app = allocs[j] && allocs[j].discount_application;
        if (app && app.title) return app.title;
      }
      if (it.discounts && it.discounts.length && it.discounts[0].title) return it.discounts[0].title;
    }
    /* Last resort. A cart level application names no line, so it cannot be
       attributed to our lines by id. It is only reached when the caller has
       already proved this add created new savings, which is what makes it safe. */
    var cartLevel = cart.cart_level_discount_applications || [];
    if (cartLevel.length && cartLevel[0].title) return cartLevel[0].title;
    return '';
  }

  /* Shopify frees the cheapest eligible lines, not necessarily the ones chosen,
     so read the real figure back rather than trusting our own arithmetic.

     o.before is the cart's total_discount as it stood BEFORE this add, or null if
     that read failed. Reporting the delta keeps savings the cart already carried
     out of our figure: without it a customer with an existing discounted line is
     told their bundle saved them that money too. With a null snapshot there is
     nothing to subtract, so fall back to the whole cart total.

     No new savings means no lines at all. Never claim a discount that did not
     happen, and never name one either.

     o.worth is always the AFTER string, the one written in the past tense,
     because by the time this runs the add has happened. The BEFORE string of
     the same line lives in each builder's render and never reaches here. */
  function savingHtml(o) {
    var lines = [];
    var now = (o.cart && typeof o.cart.total_discount === 'number') ? o.cart.total_discount : 0;
    var gained = (typeof o.before === 'number') ? now - o.before : now;

    if (gained <= 0) return '';

    if (o.showWorth && o.worth) {
      var map = { v: '<strong>' + formatMoney(gained, o.money) + '</strong>' };
      if (typeof o.qty === 'number') map.q = o.qty;
      lines.push(fill(o.worth, map));
    }

    var title = discountTitle(o.cart, o.ids);
    if (title && o.discountApplied) {
      lines.push('<span class="bb__disc">' + fill(o.discountApplied, { t: escapeHtml(title) }) + '</span>');
    }
    return lines.join('<br>');
  }

  /* total_discount as it stands right now, or null when the cart cannot be read.
     null is meaningful: it means "no snapshot", not "no discount". */
  function snapshotDiscount(done) {
    readCart(function (cart) {
      done(cart && typeof cart.total_discount === 'number' ? cart.total_discount : null);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Pattern A: mattress bundles                                         */
  /* ------------------------------------------------------------------ */

  function BundleBuilder(root) {
    this.root = root;
    this.cfg = parseAttr(root, 'data-config', {}) || {};
    this.strings = this.cfg.strings || {};
    this.money = this.cfg.moneyFormat || '${{amount}}';

    this.stepMattress = root.querySelector('[data-bb-step="mattress"]');
    this.stepExtras = root.querySelector('[data-bb-step="extras"]');
    this.extrasGrid = root.querySelector('.bb__grid--extras');
    this.counter = root.querySelector('[data-bb-counter]');
    this.summary = root.querySelector('[data-bb-summary]');
    this.submit = root.querySelector('[data-bb-submit]');
    this.submitText = root.querySelector('[data-bb-submit-text]');
    this.spinner = root.querySelector('[data-bb-spinner]');
    this.error = root.querySelector('[data-bb-error]');

    this.sizeInputs = slice(root.querySelectorAll('[data-bb-size]'));
    this.mattresses = slice(root.querySelectorAll('[data-bb-mattress]'));
    this.extras = slice(root.querySelectorAll('[data-bb-extra]'));

    this.size = null;
    this.rewardQty = this.cfg.defaultQty || 3;
    this.busy = false;

    this.bind();
    this.render();
  }

  BundleBuilder.prototype.bind = function () {
    var self = this;

    this.sizeInputs.forEach(function (input) {
      forceRadioTap(input);
      input.addEventListener('change', function () {
        if (!input.checked) return;
        self.size = input.value;
        self.rewardQty = self.qtyForSize(self.size);
        self.resolveSize();
        self.render();
      });
    });

    this.mattresses.forEach(function (wrap) {
      var input = wrap.querySelector('[data-bb-mattress-input]');
      forceRadioTap(input);
      input.addEventListener('change', function () {
        self.render();
      });
    });

    this.extras.forEach(function (wrap) {
      var input = wrap.querySelector('[data-bb-extra-input]');
      input.addEventListener('change', function () {
        if (!input.checked) {
          /* A cleared card comes back at one unit next time it is selected. */
          writeQty(wrap, 1);
        } else if (self.units() > self.rewardQty) {
          /* Hard cap, counted in UNITS. Never let the customer submit more than
             the discount rewards. A fresh tick is worth exactly one unit. */
          input.checked = false;
        }
        self.render();
      });
      bindQty(wrap, input, self);
    });

    this.submit.addEventListener('click', function () { self.addToCart(); });
  };

  /* Free extras differ by size on this store. Single, King Single and Double
     give 2, the larger sizes give 3. Driven by the section setting, not code. */
  BundleBuilder.prototype.qtyForSize = function (size) {
    var map = this.cfg.rewardQty || {};
    var n = map[size];
    return (typeof n === 'number' && n > 0) ? n : (this.cfg.defaultQty || 3);
  };

  /* An extra may name a size differently from the mattress.
     "Super King split mattress" on the mattress is "Super King" on the protector. */
  BundleBuilder.prototype.aliasFor = function (size) {
    var alias = this.cfg.sizeAlias || {};
    return alias[size] || size;
  };

  BundleBuilder.prototype.variantFor = function (wrap, size) {
    var variants = parseAttr(wrap, 'data-variants', {}) || {};
    if (wrap.getAttribute('data-single') === 'true') {
      var only = Object.keys(variants)[0];
      return only ? variants[only] : null;
    }
    return variants[this.aliasFor(size)] || variants[size] || null;
  };

  /* The TITLE of the variant variantFor just resolved, which is the key in the
     buffered variant JSON rather than a field on the value. Kept as its own
     method, in the same lookup order as variantFor, so the size confirmation
     line can never name a different variant from the one that will be added.

     For the protector on this store, a mattress size of "Super King split
     mattress" resolves through the alias map to a variant titled "Super King",
     and it is that title the customer needs to read back. */
  BundleBuilder.prototype.variantTitleFor = function (wrap, size) {
    var variants = parseAttr(wrap, 'data-variants', {}) || {};
    var has = function (k) { return Object.prototype.hasOwnProperty.call(variants, k); };
    if (wrap.getAttribute('data-single') === 'true') {
      return Object.keys(variants)[0] || '';
    }
    var alias = this.aliasFor(size);
    if (has(alias)) return alias;
    if (has(size)) return size;
    return '';
  };

  BundleBuilder.prototype.chosenExtras = function () {
    return this.extras.filter(function (w) {
      return w.querySelector('[data-bb-extra-input]').checked;
    });
  };

  /* Total UNITS chosen, not cards. Two of one pillow fills two of the free
     slots, which is what Shopify counts, so it is what this counts. */
  BundleBuilder.prototype.units = function () {
    return this.chosenExtras().reduce(function (sum, w) {
      return sum + readQty(w);
    }, 0);
  };

  /* The ceiling the quantity control works against. Pattern A rewards an exact
     number of units for the chosen size, so that number is also the cap. */
  BundleBuilder.prototype.unitCap = function () {
    return this.rewardQty;
  };

  BundleBuilder.prototype.chosenMattress = function () {
    for (var i = 0; i < this.mattresses.length; i++) {
      if (this.mattresses[i].querySelector('[data-bb-mattress-input]').checked) return this.mattresses[i];
    }
    return null;
  };

  /* Re-resolve every card against the newly chosen size and clear any stale
     selection, so a size change can never leave a wrong size variant behind. */
  BundleBuilder.prototype.resolveSize = function () {
    var self = this;
    var size = this.size;

    this.mattresses.forEach(function (wrap) {
      var input = wrap.querySelector('[data-bb-mattress-input]');
      var priceEl = wrap.querySelector('[data-bb-mattress-price]');
      var soldEl = wrap.querySelector('[data-bb-mattress-soldout]');
      var v = self.variantFor(wrap, size);
      var ok = !!(v && v.available);

      if (input.checked && !ok) input.checked = false;
      input.disabled = !ok;
      wrap.setAttribute('data-variant-id', ok ? v.id : '');
      priceEl.textContent = v ? formatMoney(v.price, self.money) : '';
      soldEl.hidden = ok;
    });

    this.extras.forEach(function (wrap) {
      var input = wrap.querySelector('[data-bb-extra-input]');
      var rrpEl = wrap.querySelector('[data-bb-extra-rrp]');
      var soldEl = wrap.querySelector('[data-bb-extra-soldout]');
      var v = self.variantFor(wrap, size);
      var ok = !!(v && v.available);

      /* Always clear on a size change. Re-picking is cheap, a stale wrong size
         variant silently voids the whole discount. The quantity clears with the
         selection, so a card returns at one unit next time it is picked. */
      input.checked = false;
      writeQty(wrap, 1);
      input.disabled = !ok;
      wrap.setAttribute('data-variant-id', ok ? v.id : '');
      wrap.setAttribute('data-price', v ? v.price : '0');
      if (v) rrpEl.textContent = formatMoney(v.price, self.money);
      rrpEl.hidden = !ok;
      soldEl.hidden = ok;

      /* Size confirmation, on the size scoped extras only. The element exists
         only on a multi variant card, so a single variant pillow simply has
         nothing to fill. textContent, not innerHTML: this is merchant text with
         a variant title substituted into it and carries no markup.

         Hidden whenever the card did not resolve, so an unavailable protector
         never claims to match a size it does not come in. */
      var matchEl = wrap.querySelector('[data-bb-size-match]');
      if (matchEl) {
        var tpl = self.strings.sizeMatch;
        var title = ok ? self.variantTitleFor(wrap, size) : '';
        if (tpl && title) {
          matchEl.textContent = fill(tpl, { size: title });
          matchEl.hidden = false;
        } else {
          matchEl.textContent = '';
          matchEl.hidden = true;
        }
      }
    });
  };

  BundleBuilder.prototype.render = function () {
    var self = this;
    var s = this.strings;
    var hasSize = !!this.size;
    var mattress = this.chosenMattress();
    var chosen = this.chosenExtras();
    var n = this.rewardQty;
    /* Everything downstream counts units, not cards. */
    var units = this.units();
    var remaining = n - units;

    this.stepMattress.classList.toggle('is-locked', !hasSize);
    this.stepExtras.classList.toggle('is-locked', !hasSize || !mattress);
    this.extrasGrid.classList.toggle('is-full', units >= n);

    /* Extras stay locked until a mattress is chosen, because the mattress is
       what triggers the offer. */
    var extrasReady = hasSize && !!mattress;
    this.extras.forEach(function (wrap) {
      var input = wrap.querySelector('[data-bb-extra-input]');
      var available = wrap.getAttribute('data-variant-id');
      input.disabled = !extrasReady || !available;
      renderQty(wrap, input, self);
    });

    this.counter.textContent = hasSize ? fill(s.chosen, { a: units, n: n }) : '';

    var worth = chosen.reduce(function (sum, w) {
      return sum + (parseInt(w.getAttribute('data-price'), 10) || 0) * readQty(w);
    }, 0);

    if (!hasSize) {
      this.summary.textContent = '';
    } else if (!mattress) {
      this.summary.textContent = '';
    } else if (this.cfg.showWorth && units) {
      /* worthPending, not worth. This line is a LIVE ESTIMATE from the cards on
         screen and the customer has added nothing yet, so it has to be written
         in the present tense: "are worth [v] so far", never "you have received".
         reconcileSaving replaces it with the worth string once the add has gone
         through and the real figure is known. Two settings, one per state, so
         neither has to be worded vaguely enough to cover both. */
      this.summary.innerHTML = fill(s.worthPending, { v: '<strong>' + formatMoney(worth, this.money) + '</strong>' });
    } else {
      this.summary.textContent = '';
    }

    var label;
    if (!hasSize) label = s.chooseSize;
    else if (!mattress) label = s.chooseMattress;
    else if (remaining > 0) label = fill(s.chooseMore, { n: remaining });
    else label = fill(s.addBundle, { n: n });

    this.submitText.textContent = label;
    /* Exact total, still. The discount is all or nothing, so the units have to
       land on the reward count and not merely reach it. */
    this.submit.disabled = this.busy || !hasSize || !mattress || units !== n;
  };

  BundleBuilder.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.spinner.hidden = !busy;
    this.submit.disabled = busy || this.submit.disabled;
    if (!busy) this.render();
  };

  BundleBuilder.prototype.showError = function (msg) {
    this.error.textContent = msg || this.strings.errorGeneric || 'Something went wrong.';
    this.error.hidden = false;
  };

  BundleBuilder.prototype.addToCart = function () {
    var self = this;
    var mattress = this.chosenMattress();
    var chosen = this.chosenExtras();

    if (this.busy) return;
    if (!mattress || this.units() !== this.rewardQty) return;

    this.error.hidden = true;
    this.setBusy(true);

    /* One line per chosen card, carrying that card's quantity. Duplicate reward
       units arrive back as a single cart line with quantity 2, which the drawer
       displays cleanly. Verified live, August 2026. */
    var items = [{ id: Number(mattress.getAttribute('data-variant-id')), quantity: 1 }];
    chosen.forEach(function (w) {
      items.push({ id: Number(w.getAttribute('data-variant-id')), quantity: readQty(w) });
    });

    if (items.some(function (i) { return !i.id; })) {
      this.setBusy(false);
      this.showError();
      return;
    }

    var ids = items.map(function (i) { return i.id; });

    /* Snapshot first, add second. The figure shown afterwards is the difference,
       so it is what this bundle earned rather than the cart's running total. */
    snapshotDiscount(function (before) {
      postCart(items)
        .then(function (res) {
          if (res.status) {
            self.setBusy(false);
            self.showError(res.description || res.message);
            return;
          }
          openCartDrawer(res.sections);
          self.reconcileSaving(before, ids);
          self.setBusy(false);
        })
        .catch(function () {
          self.setBusy(false);
          self.showError();
        });
    });
  };

  /* Replaces the pre-add estimate with what Shopify actually did. A read that
     came back and shows no new saving clears the line rather than leaving the
     estimate standing, because by then the estimate is known to be wrong. A read
     that failed outright changes nothing: unverified is not the same as zero. */
  BundleBuilder.prototype.reconcileSaving = function (before, ids) {
    var self = this;
    readCart(function (cart) {
      if (!cart) return;
      self.summary.innerHTML = savingHtml({
        worth: self.strings.worth,
        discountApplied: self.strings.discountApplied,
        money: self.money,
        showWorth: self.cfg.showWorth,
        cart: cart,
        before: before,
        ids: ids
      });
    });
  };

  /* ------------------------------------------------------------------ */
  /* Pattern B: essential bundles                                        */
  /* ------------------------------------------------------------------ */

  function EssentialBuilder(root) {
    var self = this;

    this.root = root;
    this.cfg = parseAttr(root, 'data-config', {}) || {};
    this.strings = this.cfg.strings || {};
    this.money = this.cfg.moneyFormat || '${{amount}}';
    this.reward = this.cfg.reward || null;

    /* tiers: { itemsBought: rewardsFree }. Keys arrive as JSON strings. */
    this.tiers = {};
    var raw = this.cfg.tiers || {};
    Object.keys(raw).forEach(function (k) {
      var buy = parseInt(k, 10);
      var free = parseInt(raw[k], 10);
      if (buy > 0 && free > 0) self.tiers[buy] = free;
    });

    /* Selection cap. Buying past the top tier still qualifies for the discount,
       but an uncapped grid reads as broken, so selection stops at the setting,
       default the top tier. Zero means uncapped. */
    this.maxItems = parseInt(this.cfg.maxItems, 10) || 0;
    this.steps = Object.keys(this.tiers).map(Number).sort(function (a, b) { return a - b; });

    this.counter = root.querySelector('[data-eb-counter]');
    this.summary = root.querySelector('[data-eb-summary]');
    this.submit = root.querySelector('[data-eb-submit]');
    this.submitText = root.querySelector('[data-eb-submit-text]');
    this.spinner = root.querySelector('[data-eb-spinner]');
    this.error = root.querySelector('[data-eb-error]');

    this.rewardCard = root.querySelector('[data-eb-reward]');
    this.rewardState = root.querySelector('[data-eb-reward-state]');
    this.rewardFree = root.querySelector('[data-eb-reward-free]');
    this.upsell = root.querySelector('[data-eb-upsell]');
    this.progressBar = root.querySelector('[data-eb-progress-bar]');

    this.items = slice(root.querySelectorAll('[data-eb-item]'));
    this.busy = false;

    this.hydrateFromSibling();
    this.bind();
    this.render();
  }

  /* This section renders after the store's render wide variant budget is spent,
     so a multi variant trigger, on this store the mattress protector, can arrive
     scoped to a single variant with no size dropdown. The mattress bundle
     section reads accessories inside its clean window and prints each one's
     full variant JSON on its extras cards, so when both sections share a page
     the missing dropdown is rebuilt here from that data. Standalone, with no
     sibling to borrow from, the card simply stays single variant. */
  EssentialBuilder.prototype.hydrateFromSibling = function () {
    var self = this;
    var excluded = (this.cfg.excluded || []).map(function (s) {
      return String(s).trim().toLowerCase();
    });

    this.items.forEach(function (wrap) {
      if (wrap.getAttribute('data-single') !== 'true') return;
      var input = wrap.querySelector('[data-eb-input]');
      if (!input || !input.value) return;

      var twin = document.querySelector(
        '[data-bundle-builder] [data-bb-extra] [data-bb-extra-input][value="' + input.value + '"]'
      );
      if (!twin) return;
      var variants = parseAttr(twin.closest('[data-bb-extra]'), 'data-variants', null);
      if (!variants) return;

      var allowed = Object.keys(variants).filter(function (t) {
        var v = variants[t];
        return v && v.available && excluded.indexOf(t.trim().toLowerCase()) === -1;
      });
      if (allowed.length < 2) return;

      var selId = input.id + '-size';
      var holder = document.createElement('div');
      holder.className = 'bb-eb__variant';
      var label = document.createElement('label');
      label.className = 'bb-eb__variant-label';
      label.setAttribute('for', selId);
      label.textContent = self.cfg.sizeLabel || 'Size';
      var select = document.createElement('select');
      select.className = 'bb-eb__select';
      select.id = selId;
      select.setAttribute('data-eb-variant', '');
      allowed.forEach(function (t) {
        var v = variants[t];
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.setAttribute('data-price', v.price);
        opt.textContent = t + ' ' + formatMoney(v.price, self.money);
        select.appendChild(opt);
      });
      holder.appendChild(label);
      holder.appendChild(select);
      /* The quantity row is server rendered as the wrap's last child and has to
         stay there, so the size picker slots in above it rather than on the
         end. Without a quantity row, appending is the old behaviour. */
      var qtyRow = wrap.querySelector('[data-bb-qty]');
      if (qtyRow) { wrap.insertBefore(holder, qtyRow); } else { wrap.appendChild(holder); }

      wrap.setAttribute('data-single', 'false');
      wrap.classList.add('bb-eb__wrap--sized');
      wrap.setAttribute('data-variant-id', variants[allowed[0]].id);
      wrap.setAttribute('data-price', variants[allowed[0]].price);
      wrap.setAttribute('data-available', 'true');
    });
  };

  EssentialBuilder.prototype.bind = function () {
    var self = this;

    this.items.forEach(function (wrap) {
      var input = wrap.querySelector('[data-eb-input]');
      if (input) input.addEventListener('change', function () {
        if (!input.checked) {
          /* A cleared card comes back at one unit next time it is selected. */
          writeQty(wrap, 1);
        } else if (self.maxItems > 0 && self.units() > self.maxItems) {
          /* Hard cap in UNITS, mirroring the mattress builder: a tick past the
             maximum unticks itself. Deselecting is always allowed, so a swap is
             deselect then select. */
          input.checked = false;
        }
        self.render();
      });

      var select = wrap.querySelector('[data-eb-variant]');
      if (select) {
        select.addEventListener('change', function () {
          /* The quantity belongs to the card, not to the variant, so changing
             the size keeps it. */
          self.syncPrice(wrap);
          self.render();
        });
      }
      bindQty(wrap, input, self);
      self.syncPrice(wrap);
    });

    this.submit.addEventListener('click', function () { self.addToCart(); });
  };

  /* Keeps the card in step with the size dropdown: the printed price, and the
     wrap's own data-variant-id and data-price.

     Writing those two attributes back matters even though nothing reads them on
     a card that has a dropdown, because variantOf prefers the select. Before
     this, a protector switched from Single to Queen kept advertising the Single
     variant id on the wrap while the visible price said Queen. Nothing was
     broken by it today, but a DOM that lies is a trap for whoever reads those
     attributes next, and every other card in both builders keeps them honest.

     A card with no resolvable variant, an unavailable trigger, leaves its
     attributes exactly as the section rendered them. */
  EssentialBuilder.prototype.syncPrice = function (wrap) {
    var v = this.variantOf(wrap);
    if (!v) return;

    wrap.setAttribute('data-variant-id', v.id);
    wrap.setAttribute('data-price', v.price);

    var priceEl = wrap.querySelector('[data-eb-price]');
    if (priceEl) priceEl.textContent = formatMoney(v.price, this.money);
  };

  /* A card with a dropdown resolves to whatever the dropdown shows. A native
     select always has its first option selected, so a customer who ticks the
     card without touching the dropdown gets the first allowed size. */
  EssentialBuilder.prototype.variantOf = function (wrap) {
    var select = wrap.querySelector('[data-eb-variant]');
    if (select && select.options.length) {
      var index = select.selectedIndex > -1 ? select.selectedIndex : 0;
      var opt = select.options[index];
      return { id: Number(opt.value), price: parseInt(opt.getAttribute('data-price'), 10) || 0 };
    }
    var id = Number(wrap.getAttribute('data-variant-id'));
    if (!id) return null;
    return { id: id, price: parseInt(wrap.getAttribute('data-price'), 10) || 0 };
  };

  EssentialBuilder.prototype.selected = function () {
    return this.items.filter(function (w) {
      var input = w.querySelector('[data-eb-input]');
      return !!(input && input.checked);
    });
  };

  /* Total UNITS selected. Shopify counts units on the trigger side too, so 2x
     one pillow satisfies "buy any 2" on its own and 3x one pillow plus 2x the
     protector reaches Luxe. Verified live, August 2026. Every tier, counter,
     upsell and progress figure in this builder is driven from here. */
  EssentialBuilder.prototype.units = function () {
    return this.selected().reduce(function (sum, w) {
      return sum + readQty(w);
    }, 0);
  };

  /* The ceiling the quantity control works against. Zero means uncapped, the
     same meaning the maxItems setting already carries. */
  EssentialBuilder.prototype.unitCap = function () {
    return this.maxItems;
  };

  /* Best reward across every tier the count already satisfies, not the reward of
     the highest satisfied threshold. With the live map, 2 = 1 and 3 = 2, the two
     read the same, and 4 or more still gives 2 because the top tier keeps
     applying above its own threshold. They part company on a map someone has
     mistyped, say 3 = 2 and 4 = 1: taking the max means adding a fourth item can
     never take a reward away from the customer. */
  EssentialBuilder.prototype.rewardQty = function (count) {
    var qty = 0;
    for (var i = 0; i < this.steps.length; i++) {
      if (count >= this.steps[i]) qty = Math.max(qty, this.tiers[this.steps[i]]);
    }
    return qty;
  };

  EssentialBuilder.prototype.lowestTier = function () {
    return this.steps.length ? this.steps[0] : 0;
  };

  EssentialBuilder.prototype.highestTier = function () {
    return this.steps.length ? this.steps[this.steps.length - 1] : 0;
  };

  /* The next threshold above the current count, or 0 when the top tier is met. */
  EssentialBuilder.prototype.nextTier = function (count) {
    for (var i = 0; i < this.steps.length; i++) {
      if (this.steps[i] > count) return this.steps[i];
    }
    return 0;
  };

  EssentialBuilder.prototype.render = function () {
    var self = this;
    var s = this.strings;
    /* Units, not cards. A single card raised to 2 counts as two items bought. */
    var count = this.units();
    var qty = this.rewardQty(count);
    var lowest = this.lowestTier();
    var next = this.nextTier(count);
    var hasReward = !!(this.reward && this.reward.id);

    this.counter.textContent = fill(s.counter, { a: count, n: lowest, q: qty });

    this.items.forEach(function (wrap) {
      renderQty(wrap, wrap.querySelector('[data-eb-input]'), self);
    });

    /* At the cap, unticked cards grey out but stay keyboard reachable, the
       same affordance the mattress builder uses at its reward limit. Keyed off
       units at cap, the same figure the cap logic uses. */
    var grid = this.root.querySelector('.bb__grid');
    if (grid) grid.classList.toggle('is-full', this.maxItems > 0 && count >= this.maxItems);

    /* Reward card */
    if (this.rewardCard) {
      this.rewardCard.classList.toggle('is-active', qty > 0);
      this.rewardCard.classList.toggle('is-locked', qty < 1);
    }
    if (this.rewardFree) this.rewardFree.hidden = qty < 1;
    if (this.rewardState) {
      if (qty > 0) {
        var tpl = qty === 1 ? s.rewardActiveOne : s.rewardActiveMany;
        this.rewardState.textContent = fill(tpl, { q: qty, a: count });
      } else {
        this.rewardState.textContent = fill(s.rewardLocked, { n: lowest, a: count });
      }
    }

    /* Upsell line. Only once a tier is already earned and a further one exists,
       so the copy can safely talk about a SECOND reward. Below the lowest tier
       the reward card state line and the button carry the message instead.
       [q] is what the customer would end up with at that next threshold, so the
       copy can say "in total". rewardQty(next), not tiers[next], for the same
       reason rewardQty takes a max: on a mistyped map tiers[next] can be lower
       than what they already have, and the line would be worse than useless. */
    if (this.upsell) {
      var nextQty = next ? this.rewardQty(next) : 0;
      if (next && qty > 0 && nextQty > qty) {
        this.upsell.textContent = fill(s.nextTier, {
          n: next - count,
          q: nextQty,
          t: next
        });
        this.upsell.hidden = false;
      } else {
        this.upsell.textContent = '';
        this.upsell.hidden = true;
      }
    }

    /* Progress cue: one cumulative fill across the whole offer, units against
       the top tier, clamped at full.

       Two earlier formulas were tried and both are wrong. count/nextTier broke
       on a gapped map: with 2 = 1 and 6 = 2, item 2 dropped the bar from 50% to
       33% because the target jumped from 2 to 6. Band scaling, measuring the
       count from the highest threshold already reached up to the next one,
       fixed that but had a worse failure of its own, confirmed in browser
       testing on the live preview: it returns 0 on every tier boundary, so the
       bar EMPTIED at the exact moment the first reward unlocked. Measured
       there: 1 unit 50%, 2 units 0%, 3 units 100%. Losing all visible progress
       at the reward moment is the opposite of the reassurance the bar exists
       to give.

       Against the top tier the bar only ever moves forward, on a gapped map as
       well, and full means the offer is maxed out. With 2 = 1 and 3 = 2 that is
       33%, 67%, 100%. The tier that was just earned is announced by the reward
       card and the counter, which is where that news belongs. */
    if (this.progressBar) {
      var top = this.highestTier();
      var pct = top > 0 ? Math.round(Math.min(count / top, 1) * 100) : 0;
      this.progressBar.style.width = pct + '%';
    }

    if (this.cfg.showWorth && qty > 0 && hasReward) {
      /* worthPendingText, not worthText. Nothing has been added yet, so this is
         the present tense estimate; reconcileSaving swaps in the worth string
         with Shopify's real figure after the add. Same split as Pattern A. */
      this.summary.innerHTML = fill(this.worthPendingText(qty), {
        v: '<strong>' + formatMoney(this.reward.price * qty, this.money) + '</strong>',
        q: qty
      });
    } else {
      this.summary.textContent = '';
    }

    var label;
    if (qty > 0) {
      label = fill(this.btnReadyText(qty), { a: count, q: qty });
    } else if (count === 0) {
      label = fill(s.btnLocked, { n: lowest, a: count });
    } else {
      label = fill(s.btnProgress, { n: Math.max(lowest - count, 0), a: count });
    }
    this.submitText.textContent = label;

    /* Never let a cart that does not qualify be submitted. */
    this.submit.disabled = this.busy || qty < 1 || !hasReward;
  };

  /* One protector reads differently from two, and English will not bend to a
     single string. The section ships both and the reward count picks.

     worthText is the AFTER state, shown once the add has gone through and the
     saving has been read back from the cart. */
  EssentialBuilder.prototype.worthText = function (qty) {
    return qty === 1 ? this.strings.worthOne : this.strings.worthMany;
  };

  /* The BEFORE state of the same line: a live estimate, present tense, shown
     while the customer is still choosing. Same singular/plural rule as
     worthText, so the two states can never disagree about which form to use. */
  EssentialBuilder.prototype.worthPendingText = function (qty) {
    return qty === 1 ? this.strings.worthPendingOne : this.strings.worthPendingMany;
  };

  /* The ready button renders at BOTH tiers, so a single string would have to
     say "1 complimentary Pillow Protectors" at the lower one. Same one/many
     pair as the two lines above, picked by the same reward count. */
  EssentialBuilder.prototype.btnReadyText = function (qty) {
    return qty === 1 ? this.strings.btnReadyOne : this.strings.btnReadyMany;
  };

  EssentialBuilder.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.spinner.hidden = !busy;
    this.submit.disabled = busy || this.submit.disabled;
    if (!busy) this.render();
  };

  EssentialBuilder.prototype.showError = function (msg) {
    this.error.textContent = msg || this.strings.errorGeneric || 'Something went wrong.';
    this.error.hidden = false;
  };

  EssentialBuilder.prototype.addToCart = function () {
    var self = this;
    var chosen = this.selected();
    var qty = this.rewardQty(this.units());

    if (this.busy) return;
    if (qty < 1 || !this.reward || !this.reward.id) return;

    this.error.hidden = true;
    this.setBusy(true);

    /* One line per selected card, carrying that card's quantity. A quantity 2
       line is a single cart line, which is how Shopify counts it and how the
       drawer shows it. Verified live, August 2026. */
    var items = [];
    var missing = false;
    chosen.forEach(function (wrap) {
      var v = self.variantOf(wrap);
      if (!v || !v.id) { missing = true; return; }
      items.push({ id: v.id, quantity: readQty(wrap) });
    });

    if (missing || !items.length) {
      this.setBusy(false);
      this.showError();
      return;
    }

    /* The reward has to be a cart line. Buy X Get Y discounts an item that is
       already there, it cannot add one. */
    items.push({ id: Number(this.reward.id), quantity: qty });

    var ids = items.map(function (i) { return i.id; });

    /* Snapshot first, add second, report the difference. See savingHtml. */
    snapshotDiscount(function (before) {
      postCart(items)
        .then(function (res) {
          if (res.status) {
            self.setBusy(false);
            self.showError(res.description || res.message);
            return;
          }
          openCartDrawer(res.sections);
          self.reconcileSaving(before, ids, qty);
          self.setBusy(false);
        })
        .catch(function () {
          self.setBusy(false);
          self.showError();
        });
    });
  };

  /* Same rule as Pattern A: a cart we could read and that shows no new saving
     clears the estimate, a cart we could not read leaves it alone. */
  EssentialBuilder.prototype.reconcileSaving = function (before, ids, qty) {
    var self = this;
    readCart(function (cart) {
      if (!cart) return;
      self.summary.innerHTML = savingHtml({
        worth: self.worthText(qty),
        discountApplied: self.strings.discountApplied,
        money: self.money,
        showWorth: self.cfg.showWorth,
        cart: cart,
        before: before,
        ids: ids,
        qty: qty
      });
    });
  };

  /* ------------------------------------------------------------------ */

  function init(scope) {
    var node = scope || document;

    Array.prototype.forEach.call(node.querySelectorAll('[data-bundle-builder]'), function (root) {
      if (root.__bb) return;
      root.__bb = new BundleBuilder(root);
    });

    Array.prototype.forEach.call(node.querySelectorAll('[data-essential-builder]'), function (root) {
      if (root.__bbEssential) return;
      root.__bbEssential = new EssentialBuilder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme editor: re-init when the section is reloaded. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
